import {
  ConsumirRegistro,
  ConsumirLogin,
  ConsumirCerrarSession,
  ConsumirCambioClave,
  Cargando,
  Error,
} from "./../Types/Login.type";
import { firebaseAuth, firebaseFS } from "../Firebase/FirebaseApp";
import firebaseProviders from "../Firebase/firebaseProviders";
import {
  dispatchController,
  buscarClienteYPedidoActual,
} from "./index.actions";
import procedimientos from "../procedimientos";
import { __Colecciones, __UrlRedireccion } from "./../environment";

const { GuardarYEncriptar, ObtenerYDesencriptar } = procedimientos.prototype;
const llaveUsuario = "clienteStorage";

export const consumirRegistro = (usuario) => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    const { Usuario: Correo, Clave, Nombre } = usuario;
    let uid;

    await firebaseAuth
      .createUserWithEmailAndPassword(Correo, Clave)
      .then(async (result) => {
        uid = result.user.uid;
        result.user.updateProfile({
          displayName: Nombre,
        });

        await result.user
          .sendEmailVerification({
            url: __UrlRedireccion,
          })
          .catch((error) => {
            dispatch({
              type: Error,
              Mensaje: error.message,
            });
            return;
          });
      })
      .catch((error) => {
        dispatch({
          type: Error,
          Mensaje: error.message,
        });
        return;
      });

    const UsuarioLogin = {
      Nombre: Nombre,
      Correo: Correo,
    };

    await firebaseFS
      .collection(__Colecciones.Cliente)
      .doc(uid)
      .set(UsuarioLogin);

    const bodyJson = {
      Resultado: "S",
      Mensaje: "",
      Datos: [],
    };

    dispatchController(ConsumirRegistro, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const consumirCambioClave = (correo) => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    await firebaseAuth
      .sendPasswordResetEmail(correo, {
        url: __UrlRedireccion,
      })
      .then(() => {
        const bodyJson = {
          Resultado: "S",
          Mensaje: "",
          Datos: [],
        };

        dispatchController(ConsumirCambioClave, Error, dispatch, bodyJson);
      })
      .catch((error) => {
        dispatch({
          type: Error,
          Mensaje: error.message,
        });
      });
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const consumirLogin = (correo, clave) => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    const resultado = await firebaseAuth.signInWithEmailAndPassword(
      correo,
      clave
    );
    const { email, uid, emailVerified } = resultado.user;

    let bodyJson = {};

    if (emailVerified) {
      const UsuarioLogin = {
        Correo: email,
      };

      await firebaseFS
        .collection(__Colecciones.Cliente)
        .doc(uid)
        .update(UsuarioLogin);

      const respuesta = await buscarClienteYPedidoActual(uid);
      const { Resultado, Mensaje, Cliente } = respuesta;

      if (Resultado === "S") {
        GuardarYEncriptar(llaveUsuario, Cliente);
      }

      bodyJson = {
        Resultado: Resultado,
        Mensaje: Mensaje,
        Datos: [Cliente],
      };
    } else {
      bodyJson = {
        Resultado: "N",
        Mensaje: "Tiene que verificar su email para poder ingresar",
        Datos: [],
      };
    }

    dispatchController(ConsumirLogin, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const consumirLoginClienteGoogle = () => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    const resultado = await firebaseAuth.signInWithPopup(
      firebaseProviders.Google
    );

    const { displayName, email, photoURL, uid } = resultado.user;

    const UsuarioLogin = {
      Nombre: displayName,
      Correo: email,
      Url: photoURL,
    };

    await firebaseFS
      .collection(__Colecciones.Cliente)
      .doc(uid)
      .set(UsuarioLogin, { merge: true });

    const respuesta = await buscarClienteYPedidoActual(uid);
    const { Resultado, Mensaje, Cliente } = respuesta;

    if (Resultado === "S") {
      GuardarYEncriptar(llaveUsuario, Cliente);
    }

    const bodyJson = {
      Resultado: Resultado,
      Mensaje: Mensaje,
      Datos: [Cliente],
    };

    dispatchController(ConsumirLogin, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const consumirAutoLogin = () => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    const clienteStorage = ObtenerYDesencriptar(llaveUsuario);
    const { id } = clienteStorage;

    const respuesta = await buscarClienteYPedidoActual(id);
    let { Resultado, Mensaje, Cliente } = respuesta;

    const bodyJson = {
      Resultado: Resultado,
      Mensaje: Mensaje,
      Datos: [Cliente],
    };

    dispatchController(ConsumirLogin, Error, dispatch, bodyJson);
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};

export const consumirCerrarSession = () => async (dispatch) => {
  try {
    dispatch({
      type: Cargando,
    });

    firebaseAuth.signOut();
    localStorage.clear();

    dispatch({
      type: ConsumirCerrarSession,
      payload: {},
      Mensaje: "",
      Resultado: "S",
    });
  } catch (error) {
    dispatch({
      type: Error,
      Mensaje: error.message,
    });
  }
};
